import React from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

const position = {
  lat: 44.957123,
  lng: 11.091915,
};

export const Map: React.FC = () => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyCTkiS8POAk-GKw_PdtKSuiOtXzDlCDSuw',
  });

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={{
        width: '100%',
        height: '400px',
      }}
      center={position}
      zoom={11}
    >
      <Marker position={position} />
    </GoogleMap>
  ) : (
    <></>
  );
};
